import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { backendApi } from "../../../../shared/api/backendApi";
import type { FunnelModuleDescriptionResponse, OnboardingResponse, OnboardingStatusResponse } from "../../../../shared/models/Onboarding";

// ==========================================
// ✅ Onboarding-Freitext einreichen (useMutation)
// ==========================================
export const useSubmitOnboarding = () => {
  const queryClient = useQueryClient();

  return useMutation<OnboardingResponse, Error, string>({
    mutationFn: (freeText: string) => backendApi.submitOnboarding(freeText),
    onSuccess: () => {
      // Cache invalidieren, damit der Status neu geladen wird
      queryClient.invalidateQueries({ queryKey: ["onboarding-status"] });
    },
  });
};

// ==========================================
// ✅ Onboarding-Status abfragen (useQuery)
// ==========================================
export const useOnboardingStatus = (enabled: boolean = true) => {
  return useQuery<OnboardingStatusResponse, Error>({
    queryKey: ["onboarding-status"],
    queryFn: () => backendApi.getOnboardingStatus(),
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 Minuten
  });
};

// ==========================================
// ✅ Personalisierte Modul-Beschreibung (useQuery)
// ==========================================
export const useFunnelModuleDescription = (
  moduleId: string | null,
  enabled: boolean = true,
) => {
  return useQuery<FunnelModuleDescriptionResponse, Error>({
    queryKey: ["module-description", moduleId],
    queryFn: () => {
      if (!moduleId) {
        throw new Error("Module-ID ist erforderlich");
      }
      return backendApi.getModuleDescription(moduleId);
    },
    enabled: enabled && !!moduleId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000, // 1 Stunde (Cache wird auch serverseitig gecacht)
  });
};